import { UserAuthWrapper } from 'redux-auth-wrapper';
import {
    loadingMeSelector,
    loadingBinderSelector,
} from 'common/permissions/selectors';
import {
    createBinderPredicate,
    createStudyPredicate,
} from 'common/permissions/predicates';

import {
    manageStudyExpectationsPredicate,
    viewStudyExpectationsPredicate,
    manageStudyTeamMemberPredicate,
    manageStudyTeamMemberPredicateOld,
    manageStudyTeamMemberPredicateNew,
    manageStudyMonitorsPredicateOld,
    manageStudyMonitorsPredicateNew,
    manageStudyMonitorsPredicate,
    uploadDocumentPredicate,
    manageStudyAdminsPredicate,
} from 'common/permissions/studyPredicates';
import { studyFeatureAccess } from 'common/features/predicates';

export const UserCanCreateBinders = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: createBinderPredicate,
    FailureComponent: null
});

export const UserCanCreateStudies = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: createStudyPredicate,
    FailureComponent: null
});

export const UserCanManageStudyExpectations = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyExpectationsPredicate,
    FailureComponent: null
});

export const UserCanViewDocumentDetails = (Component, FailureComponent) => UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyExpectationsPredicate,
    FailureComponent
})(Component);

export const UserCanManageStudyAdmins = (Component, FailureComponent) => UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyAdminsPredicate,
    FailureComponent,
})(Component);

export const UserCanViewStudyExpectations = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: viewStudyExpectationsPredicate,
    FailureComponent: null
});

export const UserCanUploadFiles = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingBinderSelector,
    predicate: uploadDocumentPredicate,
    FailureComponent: null
});

export const UserCanManageStudyTeamMember = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyTeamMemberPredicate,
    FailureComponent: null
});

export const UserCanManageStudyTeamMemberOld = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyTeamMemberPredicateOld,
    FailureComponent: null
});

export const UserCanManageStudyTeamMemberNew = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyTeamMemberPredicateNew,
    FailureComponent: null
});

export const UserCanManageStudyMonitors = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyMonitorsPredicate,
    FailureComponent: null
});

export const UserCanManageStudyMonitorsOld = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyMonitorsPredicateOld,
    FailureComponent: null
});

export const UserCanManageStudyMonitorsNew = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: manageStudyMonitorsPredicateNew,
    FailureComponent: null
});

export const UsersHasStudyFeatureAccess = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: studyFeatureAccess,
    FailureComponent: null
});
